import React from 'react';
import { call, put } from 'redux-saga/effects';

import { Creators as ArquivoUploadActions } from '../ducks/arquivoUpload';

import { ArquivoUploadAPI } from '../../services/api';

export function* getAtualizacaoDeRelatorio(action) {
  const { taskId } = action.payload;
  try {
    const response = yield call(
      ArquivoUploadAPI.get,
      `/obter-atualizacao-de-relatorio-de-beneficiarios/${taskId}`
    );
    const isSuccess = response.status === 200 || false;

    yield put(
      ArquivoUploadActions.getAtualizacaoDeRelatorioSuccess(
        response.data,
        isSuccess
      )
    );
  } catch (error) {
    yield put(ArquivoUploadActions.getAtualizacaoDeRelatorioError(error));
  }
}
export function* getListaArquivos(action) {
  const { codigoContratante, paginaInicial, quantidadeMaximaPorPagina } =
    action.payload;

  try {
    const response = yield call(
      ArquivoUploadAPI.get,
      `/obter-relatorios-de-beneficiarios/${codigoContratante}/${paginaInicial}/${quantidadeMaximaPorPagina}`
    );
    const isSuccess = response.status === 200 || false;

    yield put(
      ArquivoUploadActions.getListaArquivosSuccess(response.data, isSuccess)
    );
  } catch (error) {
    yield put(ArquivoUploadActions.getListaArquivosError(error));
  }
}
export function* getArquivo(action) {
  const { arquivoId } = action.payload;

  try {
    const response = yield call(
      ArquivoUploadAPI.get,
      `obter-arquivo-de-relatorio-de-beneficiarios/${arquivoId}`
    );
    const isSuccess = response.status === 200 || false;

    yield put(ArquivoUploadActions.getArquivoSuccess(response.data, isSuccess));
  } catch (error) {
    yield put(ArquivoUploadActions.getArquivoError(error));
  }
}
